import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {SplashPage} from './splash';
import {TranslateModule} from "@ngx-translate/core";
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    SplashPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(SplashPage),
    TranslateModule.forChild()
  ]
})
export class SplashPageModule {}



// WEBPACK FOOTER //
// ./src/pages/splash/splash.module.ts